<nav class="layout-breadcrumb last-strong hotfix-breadCrumbs-template">
  <div>
    <xng-breadcrumb [separator]="itemSeparator">
      <ng-container *xngBreadcrumbItem="let breadcrumb">
        @if (breadcrumb !== BreadcrumbsEnum.Content) {
          <ng-container>
            <span class="basic-text-breadcrumb">
              {{ 'breadcrumbs.' + (breadcrumb | breadcrumbFirstPart) | translate }}{{ (breadcrumb | breadcrumbDoesContainSecondPart) ? ':' : '' }}
              {{ breadcrumb | breadcrumbSecondPart }}
            </span>
          </ng-container>
        } @else {
          <ng-container>
            <span class="home-breadcrumb">
              <i class="pi pi-home"></i>
            </span>
          </ng-container>
        }
      </ng-container>
    </xng-breadcrumb>
    <ng-template #itemSeparator>
      <span class="separator-breadcrumb">
        <i class="pi pi-chevron-right"></i>
      </span>
    </ng-template>
  </div>
  <div>
    @for (page of visiblePages(); track $index) {
      <app-button
        [label]="page.label"
        class="mr-2"
        severity="contrast"
        size="small"
        [outlined]="true"
        (click)="openPage(page, $event)"
      ></app-button>
    }

    <p-menu #subPageMenu
      [model]="subPageMenuItems()"
      [popup]="true"
      (click)="$event.stopPropagation()"
      >
      <ng-template #item let-item>
        <div
          class="p-2 cursor-pointer"
          (click)="toggleItem($event, item)"
          >
          <app-check-input
            #subPageCheck
            [id]="item.code"
            [label]="item.label"
          ></app-check-input>
        </div>
      </ng-template>
    </p-menu>
    @if (subPageMenuItems().length) {
      <app-button
        icon="pi-ellipsis-v"
        size="small"
        severity="contrast"
        [text]="true"
        (click)="subPageMenu.toggle($event)"
      ></app-button>
    }
  </div>
</nav>
